
const sliderSelectors = {
    sliderContainer: '[data-slider-container]',
    sliderPagination: '[data-slider-pagination]',
    sliderPrevious: '[data-slider-previous]',
    sliderNext: '[data-slider-next]'
};

class Slider {

    constructor(elem) {
        this.elem = elem;
        this.pagination = elem.querySelector(sliderSelectors.sliderPagination);
        this.previous = elem.querySelector(sliderSelectors.sliderPrevious);
        this.next = elem.querySelector(sliderSelectors.sliderNext);


        let args = {

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },

            navigation: {
                nextEl: this.next,
                prevEl: this.previous
            },

            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                750: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                990: {
                    slidesPerView: 4.5,
                    spaceBetween: 30,
                  loop: true,
                }
            }

        };

        this.swiper = new Swiper(this.elem, args);

    }

}

document.querySelectorAll(sliderSelectors.sliderContainer).forEach(elem => new Slider(elem) );
